import CurrencyFormat from "currency-formatter"

/**
 * Currency formatting — a LEAF module on purpose.
 *
 * `src/utils/index.ts` re-exports both these helpers and everything in
 * `payment-term-discount.ts`, and that module needs `currencyFormat`. Importing
 * it from the barrel would make the barrel import one of its own members, and
 * the barrel is not a leaf either: it pulls in `../store` (the whole Redux tree)
 * at module-evaluation time. Anything the barrel exports as a `const` or a
 * `class` — `tugrug`, `regNumber`, `HttpRequest` — would then sit in its
 * temporal dead zone for the duration of that cycle. Keeping the currency
 * helpers here means no member of the barrel ever has to import the barrel.
 */

export const tugrug = (value: number) =>
  CurrencyFormat.format(value, {
    code    : "MNT",
    format  : "%v %s",
    thousand: "'",
    decimal : ".",
  })

export function currencyFormat(num: number) {
  if (isNaN(num)) return "-"
  const rounded = Math.round(num)
  return rounded.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",") + "₮"
}
